<template>
  <div>
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <section class="login-content">
      <div class="my-4 text-white text-center">
        <h2>ระบบไอทีภาระงาน</h2>
        <h2>Workload IT System</h2>
      </div>
      <div class="login-box" style="min-height: 550px">
        <form
          @submit.prevent="handleSubmit"
          class="login-form needs-validation"
          ref="form"
          novalidate
        >
          <h3 class="login-head">
            <i class="fa fa-lg fa-fw fa-user"></i>ลงทะเบียน
          </h3>
          <div class="form-group">
            <label class="control-label">ชื่อ-นามสกุล</label>
            <input
              v-model="data.name"
              class="form-control"
              type="text"
              placeholder="Name"
              required
            />
          </div>
          <div class="form-group">
            <label class="control-label">EMAIL</label>
            <input
              v-model="data.email"
              class="form-control"
              type="email"
              placeholder="Email"
              required
            />
          </div>
          <div class="form-group">
            <label class="control-label">รหัสผ่าน</label>
            <input
              v-model="data.password"
              class="form-control"
              type="password"
              placeholder="Password"
              required
            />
          </div>
          <div class="form-group">
            <label class="control-label">ยืนยันรหัสผ่าน</label>
            <input
              v-model="data.password_confirmation"
              class="form-control"
              type="password"
              placeholder="Confirm Password"
              required
            />
          </div>
          <div class="form-group"></div>
          <div class="form-group btn-container">
            <button class="btn btn-primary btn-block">
              <i class="fas fa-sign-in-alt fa-fw"></i> ลงทะเบียน
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    clear() {
      this.data = {};
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        await this.$refs.form.classList.add("was-validated");
        return;
      }
      await this.register();
      await this.clear();
      await this.$router.push({ name: "Login" });
      await this.$refs.form.classList.remove("was-validated");
    },
    register() {
      this.$http
        .post("register", this.data)
        .then((res) => {
          console.log(res.data);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style>
</style>